import React, { useEffect, useState } from "react";
import SectionSubHeader from "../components/sectionSubHeader";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import Footer from "../layouts/Footer";
import { motion } from "motion/react";
import { Helmet } from "react-helmet";
import Header from "../layouts/Header";
import SectionHeader from "../components/sectionHeader";
const PrivacyPolicy = () => {
  const [hasLoaded, setHasLoaded] = useState(false);

  useEffect(() => {
    window.scroll({
      top: 0,
      behavior: "smooth",
    });
    const timer = setTimeout(() => setHasLoaded(true), 100);
    return () => clearTimeout(timer);
  }, []);
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: hasLoaded ? 1 : 0 }}
      transition={{ duration: 0.7 }}
    >
      <Helmet>
        <title>Volto Consulting | Business &amp; Technology Solutions</title>
        <meta
          name="description"
          content="Volto Consulting provides innovative business and technology solutions to drive success in a digital world."
        />
        <meta
          name="keywords"
          content="Volto Consulting, business consulting, IT solutions, technology strategy, digital transformation"
        />
        <meta name="author" content="Volto Consulting" />
        <meta
          property="og:title"
          content="Volto Consulting | Business &amp; Technology Solutions"
        />
        <meta
          property="og:description"
          content="Volto Consulting offers expert business and IT consulting services to enhance your digital transformation journey."
        />
      </Helmet>
      <div className="volto-privacy-policy ">
        <Header mode="light" />
        <div class="voloto-banner">
      <Container className='h-85'>
        <Row className=''>
          <Col lg={10} md={10} className=''>
            <SectionHeader mainText1="PP AND T&C"  />
            <h1>Privacy Policy and Terms & Conditions</h1>
          </Col>
        </Row>
      </Container>
      
     <img className='banner-vector' src="images/Union.svg" alt="vector" />
    </div>
        <Container className="mt-lg-0 mt-5">
          <Row>
            <Col lg={{ span: 8, offset: 2 }}>
              <SectionSubHeader headerText="Introduction" />
              <p className="privacy-text mt-4">
                Welcome to Volto Consulting. By accessing our website and
                services, you agree to comply with the terms outlined in this
                policy. This document governs our professional conduct, data
                handling, and service commitments.
              </p>
            </Col>
          </Row>
          <Row className="volto-section">
            <Col lg={{ span: 8, offset: 2 }}>
              <SectionSubHeader headerText="Privacy Policy" />
              <h4 className="privacy-sub mt-5">1. Privacy Policy</h4>
              <p className="privacy-text">
                We are committed to protecting your privacy. Any personal
                information collected is used solely for business purposes,
                including client communication, recruitment, and service
                improvements. We do not sell or share personal data with third
                parties except as required by law.
              </p>
              <h4 className="privacy-sub mt-5">2. Data Security</h4>
              <p className="privacy-text">
                Volto Consulting takes data security seriously. We implement
                industry-standard measures to safeguard information from
                unauthorized access, alteration, or disclosure. However, while
                we strive to protect your data, we cannot guarantee complete
                security.
              </p>
            </Col>
          </Row>
          <Row className="volto-section">
            <Col lg={{ span: 8, offset: 2 }}>
              <SectionSubHeader headerText="Terms & Conditions" />
              <h4 className="privacy-sub mt-5">1. Compliance and Ethics</h4>
              <p className="privacy-text">
                We adhere to all applicable laws and ethical standards in
                staffing and IT solutions. Our commitment to integrity,
                diversity, and inclusion ensures fairness in all business
                interactions.
              </p>
              <h4 className="privacy-sub mt-5">2. Service Terms</h4>
              <p className="privacy-text">
                Our services include IT staffing, workforce solutions, and
                consulting. We strive for excellence in delivery but do not
                provide warranties for uninterrupted services. Any reliance on
                our services is at your own discretion.
              </p>
              <h4 className="privacy-sub mt-5">3. Intellectual Property</h4>
              <p className="privacy-text">
                All content on our website, including text, logos, and images,
                is the property of Volto Consulting. Unauthorized use or
                reproduction is strictly prohibited.
              </p>
              <h4 className="privacy-sub mt-5">4. Third-Party Links</h4>
              <p className="privacy-text">
                Our website may contain links to external sites. Volto
                Consulting is not responsible for the content, policies, or
                practices of third-party websites.
              </p>
              <h4 className="privacy-sub mt-5">5. Limitation of Liability</h4>
              <p className="privacy-text">
                We are not liable for any direct, indirect, incidental, or
                consequential damages resulting from the use of our services or
                website.
              </p>
            </Col>
          </Row>
          <Row className="volto-section pb-80">
            <Col lg={{ span: 8, offset: 2 }}>
              <SectionSubHeader headerText="Other Provisions" />
              <h4 className="privacy-sub mt-5">1. Updates to Policy</h4>
              <p className="privacy-text">
                This policy may be updated periodically. Continued use of our
                services after changes indicates acceptance of the revised
                terms.
              </p>
              <h4 className="privacy-sub mt-5">2. Contact Information</h4>
              <p className="privacy-text">
                For any inquiries or concerns regarding this policy, please
                contact us at &nbsp;
                <Link to={"mailto:contact@voltoconsulting.com"}>
                  {" "}
                  contact@voltoconsulting.com
                </Link>
              </p>
            </Col>
          </Row>
        </Container>
        <Footer />
      </div>
    </motion.div>
  );
};

export default PrivacyPolicy;
